var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/ItemTooltip.tsx";
import React from 'react';
import { Tooltip } from '@gmini/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export var ItemTooltip = /*#__PURE__*/React.memo(function (_ref) {
  var title = _ref.title,
      children = _ref.children;
  return /*#__PURE__*/_jsx(Tooltip, {
    arrow: true,
    placement: "bottom",
    enterDelay: 1000,
    enterNextDelay: 1000,
    leaveDelay: 300,
    title: title,
    children: children
  });
});
ItemTooltip.displayName = 'ItemTooltip';